import React, { useState } from "react";
import Form from "../../../form/Form";
import Table from "../../../elements/table/Table";
import Button from "../../../form/Button";
import Modal from "../../../elements/Modal";
import ManageInviteTeammate from "./ManageInviteTeammate";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  invitation,
  organizationList,
  organizationListFront,
  organizationTeamList,
} from "../../../../services/organizationService";
import { handleFilterChange } from "../../../../helpers";
import { useSelector } from "react-redux";
import Badge from "../../../elements/Badge";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const TeamAccess = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { selectedOrganization, organizations, selectedOrganizationDetails } =
    useSelector((state) => state?.organization);
  const { session } = useSelector((state) => state?.authProvider);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });

  const {
    data: teamData,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ["team-list", filters],
    queryFn: async () => {
      const res = await organizationTeamList({
        ...filters,
        // status: "invited",
        // viewAs: "team",
        organization: selectedOrganization,
      });
      return res?.docs;
    },
  });

  const tableHeadData = [
    {
      _id: "Name",
      name: t("Name"),
      align: "left",
      isSort: false,
      isFilter: false,
    },
    {
      _id: "Roles",
      name: t("Roles"),
      align: "left",
      isSort: false,
      isFilter: false,
    },
    {
      _id: "Email",
      name: t("Email"),
      align: "left",
      isSort: false,
      isFilter: false,
    },
    {
      _id: "status",
      name: t("status"),
      align: "left",
      isSort: false,
      isFilter: false,
    },
    selectedOrganizationDetails?.data?.userData?._id === session?.user?._id && {
      _id: "actions",
      name: t("Action"),
      align: "right",
      isSort: false,
      isFilter: false,
    },
  ]?.filter(Boolean);

  const tableData = teamData?.data?.map((item) => {
    const userName = `${item?.userData?.firstName || ""} ${
      item?.userData?.lastName || ""
    }`;

    return {
      _id: item?._id,
      rowData: [
        {
          _id: "name",
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px] !max-w-none !w-[10%]",
          data: userName.trim() || "-",
        },
        {
          _id: "role",
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px] !max-w-none !w-[10%]",
          data: item?.role || "-",
        },
        {
          _id: "email",
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px] !max-w-none !w-[10%]",
          data: item?.userData?.email || "-",
        },
        {
          _id: "status",
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px] !max-w-none !w-[10%]",
          data: item?.status ? (
            <Badge
              label={item?.status === "invited" ? "invited" : "Accepted"}
              type={item?.status === "invited" ? "danger" : "success"}
            />
          ) : (
            "-"
          ),
        },
        selectedOrganizationDetails?.data?.userData?._id ===
          session?.user?._id && {
          _id: "actions",
          type: "action",
          align: "right",
          cellClass: "!w-[1%]",
          actionData: [
            {
              _id: "edit",
              name: t("Edit"),
              icon: "fa-regular fa-pen-to-square",
              onClick: () => {
                setModalOpen({ isOpen: true, data: item });
              },
              standout: false,
            },
            item?.status === "invited" && {
              _id: "invite",
              name: t("invite"),
              icon: "fa-regular fa-envelope",
              onClick: () => {
                invitation({
                  emails: [item?.userData?.email],
                  organization: selectedOrganization,
                }).then((res) => {
                  if (res?.status === 200) {
                    toast.success(res?.message);
                  }
                });
              },
              standout: false,
            },
          ]?.filter(Boolean),
        },
      ]?.filter(Boolean),
    };
  });

  return (
    <div className="max-w-6xl 2xl:max-w-8xl 3xl:max-w-9xl w-full mx-auto">
      <div className="mx-auto p-4 bg-white shadow rounded-md">
        <div className="py-4 md:py-8 px-3 md:px-6 rounded-md space-y-4 border border-gray-200">
          <h2 className="text-xl md:text-2xl text-deep-purple font-bold font-Montserrat">
            {t("Team access")}
          </h2>
          <div className="flex justify-end">
            <Button
              buttonLabel={t("Invite teammate")}
              buttonFunction={() => {
                setModalOpen({ isOpen: true, data: null });
              }}
              buttonClasses={"h-10 md:h-12 px-4 md:px-6"}
            />
          </div>
          <Table
            tableHeadData={tableHeadData}
            tableData={tableData}
            isLoder={isLoading}
            pageCount={teamData?.metadata?.totalPages}
            currentPage={filters?.page}
            onPageChange={(val) => {
              handleFilterChange("page", val, setFilters);
            }}
            isFetching={isFetching}
            tableActionDropdownContainer={"!w-48"}
          />
        </div>
        <ManageInviteTeammate
          open={modalOpen?.isOpen}
          data={modalOpen?.data}
          onClose={() => {
            setModalOpen({ isOpen: false, data: null });
          }}
          getResponse={(res) => {
            if (res?.status === 200) {
              setModalOpen({ isOpen: false, data: null });
              queryClient.invalidateQueries({
                queryKey: ["team-list", filters],
              });
            }
          }}
        />
      </div>
    </div>
  );
};

export default TeamAccess;
